export default __webpack_public_path__ + "static/media/github.f6795986.gif";